<template>
  <div v-if="isStock" class="product-inner__top">
    <div class="product-inner__options">
      <div class="product-inner__size">
        <div class="product-inner__size-title">{{ sizesTitle }}</div>
        <div class="product-inner__size-list">
          <div class="product-inner__size-item" v-for="size in sizes" :key="size.id">
            <div data-min="">{{ size.min }}</div>
            <InputText v-if="isStock"
                       :placeholder="size.placeholder || size.name"
                       :label="size.name"
                       :required="size.isRequired"
                       :name="size.code"
                       inputmode="numeric"
                       disabled=true
                       :mask-settings="getFieldMask(size.code)"
                       :model-value="getCurSizeValue(size.code)"
                       :errors="errorsForm"
                       @update:model-value="setValue(size.code, size.type, $event)"
            />

            <InputRange v-else
                        :placeholder="size.placeholder || size.name"
                        :label="size.name"
                        :mask-settings="getFieldMask(size.code)"
                        :max="getSizeValue('max', size.code)"
                        :min="getSizeValue('min', size.code)"
                        :start="getSizeValue('min', size.code)"
                        :step="size.step"
                        :required="size.isRequired"
                        :name="size.code"
                        :model-value="getCurSizeValue(size.code)"
                        :errors="errorsForm"
                        @update:model-value="setValue(size.code, size.type, $event)"
            />
          </div>
        </div>
      </div>
      <div class="product-inner__options-item product-inner__accordeon accordeon">
        <div v-if="countLayers.length > 0 || profileCardboard.length > 0 || colorFrontCardboard.length > 0"
             class="accordeon__item accordeon__item--border" data-dropdown>
          <div class="accordeon__item-top">
            <span class="accordeon__item-name">{{ cartBoardTitle }}</span>
            <span class="accordeon__item-toggle">{{ cartToggle }}</span>
            <span class="accordeon__item-popup" data-fancybox-accordeon href="#pio-1"></span>
          </div>
          <div class="accordeon__item-content fancy-dropdow" id="pio-1">
            <div class="accordeon__item-close fancy-dropdow__close"></div>
            <div class="accordeon__item-body fancy-dropdow__cont">
              <span v-if="countLayers.length > 0" class="accordeon__item-title">{{ cartBoardTitle }}</span>
              <fieldset v-if="countLayers.length > 0" class="form-group">
                <legend class="form-group__label">{{ cartBoardText }}</legend>
                <div class="form-group__list form-group__list--auto">
                  <div v-for="item in countLayers" :key="item.id" class="form-group__item">
                    <div class="form-group__item-input">
                      <div class="default-radio">
                        <input v-model="selectedCountLayers" class="default-radio__input"
                               :value="item.id"
                               name="selectCountLayers" type="radio"
                               :id="'countLayers-'+item.id">
                        <label class="default-radio__label" :for="'countLayers-'+item.id">
                          <div class="default-radio__img">
                            <img v-if="item.img" :src="item.img" alt="alt" loading="lazy">
                          </div>
                          <span class="default-radio__name">{{ item.name }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset v-if="profileCardboardCustom.length > 0" class="form-group">
                <legend class="form-group__label">{{ cartProfileTitle }}</legend>
                <div class="form-group__list form-group__list--auto">
                  <div v-for="item in profileCardboardCustom" :key="item.id" class="form-group__item">
                    <div class="form-group__item-input">
                      <div class="default-radio" :class="{'disabled':item['disabled']}">
                        <input v-model="selectedProfileCardboard" class="default-radio__input"
                               :value="item.id"
                               name="radioProfileCardboard" type="radio"
                               :id="'profileCardboard-'+item.id">
                        <label class="default-radio__label" :for="'profileCardboard-'+item.id">
                          <div class="default-radio__img">
                            <img v-if="item.img" :src="item.img" alt="alt" loading="lazy">
                          </div>
                          <span class="default-radio__name">{{ item.name }}</span>
                        </label>
                        <div v-if="item.description" class="tooltip">
                          <span class="tooltip__btn">?</span>
                          <div class="tooltip__content">
                            <p>{{ item.description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group__item-text"><span>{{ item.text }}</span></div>
                  </div>
                </div>
              </fieldset>
              <fieldset v-if="colorFrontCardboard.length > 0" class="form-group">
                <legend class="form-group__label">{{ cartColorTitle }}</legend>
                <div class="form-group__radios form-group__radios--2">
                  <div v-for="item in colorFrontCardboard" :key="item.id"
                       class="form-group__radios-item">
                    <div class="default-radio">
                      <input v-model="selectedColorFrontCardboard" class="default-radio__input"
                             type="radio"
                             name="selectColorFrontCardboard" :value="item.id"
                             :id="'colorFrontCardboard-'+item.id">
                      <label class="default-radio__label" :for="'colorFrontCardboard-'+item.id">
                        <span class="default-radio__name">{{ item.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
              <div class="accordeon__item-btns">
                <button class="default-btn default-btn--green" data-close @click="ApplyClick">
                  {{ cartApply }}
                </button>
                <button class="default-btn default-btn--base" data-close @click="ResetParametersClick">
                  {{ cartReset }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="selectedCountLayers || selectedProfileCardboard || selectedColorFrontCardboard"
               class="accordeon__item-bottom">
            <ul class="product-inner__options-checked">
              <li v-if="selectedCountLayers">{{
                  getRadioChekboxTextValue(selectedCountLayers, countLayers)
                }}
              </li>
              <li v-if="selectedProfileCardboard">{{
                  getRadioChekboxTextValue(selectedProfileCardboard, profileCardboard)
                }}
              </li>
              <li v-if="selectedColorFrontCardboard">
                {{ getRadioChekboxTextValue(selectedColorFrontCardboard, colorFrontCardboard) }}
              </li>
            </ul>
          </div>
        </div>
        <div v-if="seal.length > 0" class="accordeon__item accordeon__item--border" data-dropdown>
          <div class="accordeon__item-top">
            <span class="accordeon__item-name">{{ cartPrintingTitle }}</span>
            <span class="accordeon__item-toggle">{{ cartToggle }}</span>
            <span class="accordeon__item-popup" data-fancybox-accordeon href="#pio-2"></span>
          </div>
          <div class="accordeon__item-content fancy-dropdow" id="pio-2">
            <div class="accordeon__item-close fancy-dropdow__close"></div>
            <div class="accordeon__item-body fancy-dropdow__cont">
              <span class="accordeon__item-title">{{ cartPrintingTitle }}</span>
              <fieldset class="form-group">
                <legend class="form-group__label">{{ cartPrintingText }}</legend>
                <div class="form-group__radios form-group__radios--2">
                  <div v-for="item in seal" :key="item.id" class="form-group__radios-item">
                    <div class="default-radio">
                      <input v-model="selectedSeal" :value="item.id" class="default-radio__input"
                             type="radio" name="seal"
                             :id="'seal-'+item.id">
                      <label class="default-radio__label" :for="'seal-'+item.id"><span
                          class="default-radio__name">{{ item.name }}</span></label>
                    </div>
                  </div>

                  <div v-if="selectedSeal == 1"
                       class="form-group__radios-fieldset form-group__radios-fieldset--border form-group__radios-fieldset--left">
                    <div class="form__items">
                      <div v-for="item in typePrint" :key="item.id" class="form__item">
                        <div class="default-radio">
                          <input v-model="selectedTypePrint" :value="item.id"
                                 class="default-radio__input" type="radio"
                                 name="typePrint" :id="'typePrint-'+item.id">
                          <label class="default-radio__label"
                                 :for="'typePrint-'+item.id"><span
                              class="default-radio__name">{{ item.name }}</span></label>
                        </div>
                      </div>
                    </div>
                    <div class="form__items">
                      <div class="form__items-text">{{ cartPrintingText2 }} <br>{{ cartPrintingText3 }}
                      </div>
                      <div class="form__item">
                        <InputFile id="typePrintFile"
                                   name="typePrintFile"
                                   accept=".cdr, .ai, .pdf, .jpg, .jpeg, .png"
                                   :placeholder="filePlaceHolder"
                                   :model-value="this.selectedTypePrintFile"
                                   :errors="errorsForm"
                                   @update:model-value="setFileValue($event)"
                        />
                      </div>
                      <div class="form__item">
                        <div class="default-textarea">
                          <div class="default-textarea__body">
                            <textarea v-model="selectedTypePrintComment" class="default-textarea__textarea"
                                      :placeholder="cartCommentText" rows="1"></textarea>
                            <label class="default-textarea__label">{{ cartCommentText }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="accordeon__item-btns">
              <button class="default-btn default-btn--green" data-close @click="ApplyClick">{{ cartApply }}
              </button>
              <button class="default-btn default-btn--base" data-close @click="ResetSealClick">{{ cartReset }}
              </button>
            </div>
          </div>
          <div v-if="selectedSeal || selectedTypePrint || selectedTypePrintFile || selectedTypePrintComment"
               class="accordeon__item-bottom">
            <ul class="product-inner__options-checked">
              <li v-if="selectedSeal">{{ getRadioChekboxTextValue(selectedSeal, seal) }}</li>
              <li v-if="selectedSeal !== '2' && selectedTypePrint">
                {{ getRadioChekboxTextValue(selectedTypePrint, typePrint) }}
              </li>
              <li v-if="selectedSeal !== '2' && selectedTypePrintFile">{{ getTypePrintFileName() }}
              </li>
              <li v-if="selectedSeal !== '2' && selectedTypePrintComment">{{ selectedTypePrintComment }}
              </li>
            </ul>
          </div>
        </div>
        <div v-if="additionalParams.length > 0 || accessories.length > 0"
             class="accordeon__item accordeon__item--border" data-dropdown>
          <div class="accordeon__item-top">
            <span class="accordeon__item-name">{{ cartAdditionally1 }}</span>
            <span class="accordeon__item-toggle">{{ cartToggle }}</span>
            <span class="accordeon__item-popup" data-fancybox-accordeon href="#pio-3"></span>
          </div>
          <div class="accordeon__item-content fancy-dropdow" id="pio-3">
            <div class="accordeon__item-close fancy-dropdow__close"></div>
            <div class="accordeon__item-body fancy-dropdown__cont"><span
                class="accordeon__item-title">{{ cartAdditionally1 }}</span>
              <fieldset v-if="additionalParams.length > 0" class="form-group">
                <legend class="form-group__label">{{ cartAdditionally2 }}</legend>
                <div class="form-group__list form-group__list--auto">
                  <div v-for="item in additionalParams" :key="item.id" class="form-group__item">
                    <div class="form-group__item-input">
                      <div class="default-checkbox">
                        <input v-model="selectedAdditionalParams"
                               name="selectedAdditionalParams[]" :value="item.id"
                               class="default-checkbox__input" type="checkbox"
                               :id="'additionalParams-'+item.id">
                        <label class="default-checkbox__label"
                               :for="'additionalParams-'+item.id">
                          <div class="default-checkbox__img">
                            <img v-if="item.img" :src="item.img" alt="alt" loading="lazy">
                          </div>
                          <span class="default-checkbox__name">{{ item.name }}</span>
                        </label>
                        <div v-if="item.description" class="tooltip">
                          <span class="tooltip__btn">?</span>
                          <div class="tooltip__content">
                            <p>{{ item.description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset v-if="accessories.length > 0" class="form-group">
                <legend class="form-group__label">{{ cartAdditionally3 }}</legend>
                <div class="form-group__list form-group__list--auto">
                  <div v-for="item in accessories" :key="item.id" class="form-group__item">
                    <div class="form-group__item-input">
                      <div class="default-checkbox">
                        <input v-model="selectedAccessories" name="selectedAccessories[]"
                               class="default-checkbox__input"
                               :value="item.id" type="checkbox" :id="'accessories-'+item.id">
                        <label class="default-checkbox__label" :for="'accessories-'+item.id">
                          <div class="default-checkbox__img">
                            <img v-if="item.img" :src="item.img" alt="alt" loading="lazy">
                          </div>
                          <span class="default-checkbox__name">{{ item.name }}</span>
                        </label>
                        <div v-if="item.description" class="tooltip">
                          <span class="tooltip__btn">?</span>
                          <div class="tooltip__content">
                            <p>{{ item.description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="accordeon__item-btns">
              <button class="default-btn default-btn--green" data-close @click="ApplyClick">{{ cartApply }}
              </button>
              <button class="default-btn default-btn--base" data-close @click="ResetAdditionalClick">
                {{ cartReset }}
              </button>
            </div>
          </div>
          <div v-if="selectedAdditionalParams.length || selectedAccessories.length"
               class="accordeon__item-bottom">
            <ul class="product-inner__options-checked">
              <li v-for="id in selectedAdditionalParams" :key="id">{{
                  getRadioChekboxTextValue(id, additionalParams)
                }}
              </li>
              <li v-for="id in selectedAccessories" :key="id">{{
                  getRadioChekboxTextValue(id, accessories)
                }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="product-inner__options-item product-inner__comment">
        <div class="default-textarea">
          <div class="default-textarea__body">
            <textarea v-model="selectedComment" class="default-textarea__textarea" :placeholder="cartCommentTitle"
                      rows="1"></textarea>
            <label class="default-textarea__label">{{ cartCommentTitle }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="product-inner__options">
    <div class="product-inner__size">
      <div class="product-inner__size-title">{{ sizesTitle }}</div>
      <div class="product-inner__size-list">
        <div class="product-inner__size-item" v-for="size in sizes" :key="size.id">
          <div data-min="">{{ size.min }}</div>
          <InputText v-if="isStock"
                     :placeholder="size.placeholder || size.name"
                     :label="size.name"
                     :required="size.isRequired"
                     :name="size.code"
                     inputmode="numeric"
                     disabled=true
                     :mask-settings="getFieldMask(size.code)"
                     :model-value="getCurSizeValue(size.code)"
                     :errors="errorsForm"
                     @update:model-value="setValue(size.code, size.type, $event)"
          />

          <InputRange v-else
                      :placeholder="size.placeholder || size.name"
                      :label="size.name"
                      :mask-settings="getFieldMask(size.code)"
                      :max="getSizeValue('max', size.code)"
                      :min="getSizeValue('min', size.code)"
                      :start="getSizeValue('min', size.code)"
                      :step="size.step"
                      :required="size.isRequired"
                      :name="size.code"
                      :model-value="getCurSizeValue(size.code)"
                      :errors="errorsForm"
                      @update:model-value="setValue(size.code, size.type, $event)"
          />
        </div>
      </div>
    </div>
    <div class="product-inner__options-item product-inner__accordeon accordeon">
      <div v-if="countLayers.length > 0 || profileCardboard.length > 0 || colorFrontCardboard.length > 0"
           class="accordeon__item accordeon__item--border" data-dropdown>
        <div class="accordeon__item-top">
          <span class="accordeon__item-name">{{ cartBoardTitle }}</span>
          <span class="accordeon__item-toggle">{{ cartToggle }}</span>
          <span class="accordeon__item-popup" data-fancybox-accordeon href="#pio-1"></span>
        </div>
        <div class="accordeon__item-content fancy-dropdow" id="pio-1">
          <div class="accordeon__item-close fancy-dropdow__close"></div>
          <div class="accordeon__item-body fancy-dropdow__cont">
            <span v-if="countLayers.length > 0" class="accordeon__item-title">{{ cartBoardTitle }}</span>
            <fieldset v-if="countLayers.length > 0" class="form-group">
              <legend class="form-group__label">{{ cartBoardText }}</legend>
              <div class="form-group__list form-group__list--auto">
                <div v-for="item in countLayers" :key="item.id" class="form-group__item">
                  <div class="form-group__item-input">
                    <div class="default-radio">
                      <input v-model="selectedCountLayers" class="default-radio__input"
                             :value="item.id"
                             name="selectCountLayers" type="radio" :id="'countLayers-'+item.id">
                      <label class="default-radio__label" :for="'countLayers-'+item.id">
                        <div class="default-radio__img">
                          <img v-if="item.img" :src="item.img" alt="alt" loading="lazy">
                        </div>
                        <span class="default-radio__name">{{ item.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset v-if="profileCardboardCustom.length > 0" class="form-group">
              <legend class="form-group__label">{{ cartProfileTitle }}</legend>
              <div class="form-group__list form-group__list--auto">
                <div v-for="item in profileCardboardCustom" :key="item.id" class="form-group__item">
                  <div class="form-group__item-input">
                    <div class="default-radio" :class="{'disabled':item['disabled']}">
                      <input v-model="selectedProfileCardboard" class="default-radio__input"
                             :value="item.id"
                             name="radioProfileCardboard" type="radio"
                             :id="'profileCardboard-'+item.id">
                      <label class="default-radio__label" :for="'profileCardboard-'+item.id">
                        <div class="default-radio__img">
                          <img v-if="item.img" :src="item.img" alt="alt" loading="lazy">
                        </div>
                        <span class="default-radio__name">{{ item.name }}</span>
                      </label>
                      <div v-if="item.description" class="tooltip">
                        <span class="tooltip__btn">?</span>
                        <div class="tooltip__content">
                          <p>{{ item.description }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group__item-text"><span>{{ item.text }}</span></div>
                </div>
              </div>
            </fieldset>
            <fieldset v-if="colorFrontCardboard.length > 0" class="form-group">
              <legend class="form-group__label">{{ cartColorTitle }}</legend>
              <div class="form-group__radios form-group__radios--2">
                <div v-for="item in colorFrontCardboard" :key="item.id" class="form-group__radios-item">
                  <div class="default-radio">
                    <input v-model="selectedColorFrontCardboard" class="default-radio__input"
                           type="radio"
                           name="selectColorFrontCardboard" :value="item.id"
                           :id="'colorFrontCardboard-'+item.id">
                    <label class="default-radio__label" :for="'colorFrontCardboard-'+item.id">
                      <span class="default-radio__name">{{ item.name }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="accordeon__item-btns">
              <button class="default-btn default-btn--green" data-close @click="ApplyClick">{{ cartApply }}
              </button>
              <button class="default-btn default-btn--base" data-close @click="ResetParametersClick">
                {{ cartReset }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="selectedCountLayers || selectedProfileCardboard || selectedColorFrontCardboard"
             class="accordeon__item-bottom">
          <ul class="product-inner__options-checked">
            <li v-if="selectedCountLayers">{{
                getRadioChekboxTextValue(selectedCountLayers, countLayers)
              }}
            </li>
            <li v-if="selectedProfileCardboard">{{
                getRadioChekboxTextValue(selectedProfileCardboard, profileCardboard)
              }}
            </li>
            <li v-if="selectedColorFrontCardboard">
              {{ getRadioChekboxTextValue(selectedColorFrontCardboard, colorFrontCardboard) }}
            </li>
          </ul>
        </div>
      </div>
      <div v-if="seal.length > 0" class="accordeon__item accordeon__item--border" data-dropdown>
        <div class="accordeon__item-top">
          <span class="accordeon__item-name">{{ cartPrintingTitle }}</span>
          <span class="accordeon__item-toggle">{{ cartToggle }}</span>
          <span class="accordeon__item-popup" data-fancybox-accordeon href="#pio-2"></span>
        </div>
        <div class="accordeon__item-content fancy-dropdow" id="pio-2">
          <div class="accordeon__item-close fancy-dropdow__close"></div>
          <div class="accordeon__item-body fancy-dropdow__cont">
            <span class="accordeon__item-title">{{ cartPrintingTitle }}</span>
            <fieldset class="form-group">
              <legend class="form-group__label">{{ cartPrintingText }}</legend>
              <div class="form-group__radios form-group__radios--2">
                <div v-for="item in seal" :key="item.id" class="form-group__radios-item">
                  <div class="default-radio">
                    <input v-model="selectedSeal" :value="item.id" class="default-radio__input"
                           type="radio" name="seal"
                           :id="'seal-'+item.id">
                    <label class="default-radio__label" :for="'seal-'+item.id"><span
                        class="default-radio__name">{{ item.name }}</span></label>
                  </div>
                </div>

                <div v-if="selectedSeal == 1"
                     class="form-group__radios-fieldset form-group__radios-fieldset--border form-group__radios-fieldset--left">
                  <div class="form__items">
                    <div v-for="item in typePrint" :key="item.id" class="form__item">
                      <div class="default-radio">
                        <input v-model="selectedTypePrint" :value="item.id"
                               class="default-radio__input" type="radio"
                               name="typePrint" :id="'typePrint-'+item.id">
                        <label class="default-radio__label" :for="'typePrint-'+item.id"><span
                            class="default-radio__name">{{ item.name }}</span></label>
                      </div>
                    </div>
                  </div>
                  <div class="form__items">
                    <div class="form__items-text">{{ cartPrintingText2 }} <br>{{ cartPrintingText3 }}
                    </div>
                    <div class="form__item">
                      <InputFile id="typePrintFile"
                                 name="typePrintFile"
                                 accept=".cdr, .ai, .pdf, .jpg, .jpeg, .png"
                                 :placeholder="filePlaceHolder"
                                 :model-value="this.selectedTypePrintFile"
                                 :errors="errorsForm"
                                 @update:model-value="setFileValue($event)"
                      />
                    </div>
                    <div class="form__item">
                      <div class="default-textarea">
                        <div class="default-textarea__body">
                            <textarea v-model="selectedTypePrintComment" class="default-textarea__textarea"
                                      :placeholder="cartCommentText" rows="1"></textarea>
                          <label class="default-textarea__label">{{ cartCommentText }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="accordeon__item-btns">
            <button class="default-btn default-btn--green" data-close @click="ApplyClick">{{ cartApply }}</button>
            <button class="default-btn default-btn--base" data-close @click="ResetSealClick">{{ cartReset }}
            </button>
          </div>
        </div>
        <div v-if="selectedSeal || selectedTypePrint || selectedTypePrintFile || selectedTypePrintComment"
             class="accordeon__item-bottom">
          <ul class="product-inner__options-checked">
            <li v-if="selectedSeal">{{ getRadioChekboxTextValue(selectedSeal, seal) }}</li>
            <li v-if="selectedSeal !== '2' && selectedTypePrint">
              {{ getRadioChekboxTextValue(selectedTypePrint, typePrint) }}
            </li>
            <li v-if="selectedSeal !== '2' && selectedTypePrintFile">{{ getTypePrintFileName() }}
            </li>
            <li v-if="selectedSeal !== '2' && selectedTypePrintComment">{{ selectedTypePrintComment }}
            </li>
          </ul>
        </div>
      </div>
      <div v-if="additionalParams.length > 0 || accessories.length > 0"
           class="accordeon__item accordeon__item--border" data-dropdown>
        <div class="accordeon__item-top">
          <span class="accordeon__item-name">{{ cartAdditionally1 }}</span>
          <span class="accordeon__item-toggle">{{ cartToggle }}</span>
          <span class="accordeon__item-popup" data-fancybox-accordeon href="#pio-3"></span>
        </div>
        <div class="accordeon__item-content fancy-dropdow" id="pio-3">
          <div class="accordeon__item-close fancy-dropdow__close"></div>
          <div class="accordeon__item-body fancy-dropdown__cont"><span
              class="accordeon__item-title">{{ cartAdditionally1 }}</span>
            <fieldset v-if="additionalParams.length > 0" class="form-group">
              <legend class="form-group__label">{{ cartAdditionally2 }}</legend>
              <div class="form-group__list form-group__list--auto">
                <div v-for="item in additionalParams" :key="item.id" class="form-group__item">
                  <div class="form-group__item-input">
                    <div class="default-checkbox">
                      <input v-model="selectedAdditionalParams" name="selectedAdditionalParams[]"
                             :value="item.id"
                             class="default-checkbox__input" type="checkbox"
                             :id="'additionalParams-'+item.id">
                      <label class="default-checkbox__label" :for="'additionalParams-'+item.id">
                        <div class="default-checkbox__img">
                          <img v-if="item.img" :src="item.img" alt="alt" loading="lazy">
                        </div>
                        <span class="default-checkbox__name">{{ item.name }}</span>
                      </label>
                      <div v-if="item.description" class="tooltip">
                        <span class="tooltip__btn">?</span>
                        <div class="tooltip__content">
                          <p>{{ item.description }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset v-if="accessories.length > 0" class="form-group">
              <legend class="form-group__label">{{ cartAdditionally3 }}</legend>
              <div class="form-group__list form-group__list--auto">
                <div v-for="item in accessories" :key="item.id" class="form-group__item">
                  <div class="form-group__item-input">
                    <div class="default-checkbox">
                      <input v-model="selectedAccessories" name="selectedAccessories[]"
                             class="default-checkbox__input"
                             :value="item.id" type="checkbox" :id="'accessories-'+item.id">
                      <label class="default-checkbox__label" :for="'accessories-'+item.id">
                        <div class="default-checkbox__img">
                          <img v-if="item.img" :src="item.img" alt="alt" loading="lazy">
                        </div>
                        <span class="default-checkbox__name">{{ item.name }}</span>
                      </label>
                      <div v-if="item.description" class="tooltip">
                        <span class="tooltip__btn">?</span>
                        <div class="tooltip__content">
                          <p>{{ item.description }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="accordeon__item-btns">
            <button class="default-btn default-btn--green" data-close @click="ApplyClick">{{ cartApply }}</button>
            <button class="default-btn default-btn--base" data-close @click="ResetAdditionalClick">
              {{ cartReset }}
            </button>
          </div>
        </div>
        <div v-if="selectedAdditionalParams.length || selectedAccessories.length"
             class="accordeon__item-bottom">
          <ul class="product-inner__options-checked">
            <li v-for="id in selectedAdditionalParams" :key="id">{{
                getRadioChekboxTextValue(id, additionalParams)
              }}
            </li>
            <li v-for="id in selectedAccessories" :key="id">{{
                getRadioChekboxTextValue(id, accessories)
              }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="product-inner__options-item product-inner__comment">
      <div class="default-textarea">
        <div class="default-textarea__body">
            <textarea v-model="selectedComment" class="default-textarea__textarea" :placeholder="cartCommentTitle"
                      rows="1"></textarea>
          <label class="default-textarea__label">{{ cartCommentTitle }}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="product-inner__sticky sticky-el">
    <div class="product-inner__progress">
      <div v-if="!isStock" class="progress">
        <div class="progress__title">{{ cartProgress }}</div>
        <div class="progress__list">
          <div class="progress__item" :class="{'active' : isStep1}"><span class="progress__item-line"></span>
          </div>
          <div v-if="isShowStep2" class="progress__item" :class="{'active' : isStep2}"><span
              class="progress__item-line"></span></div>
          <div v-if="isShowStep3" class="progress__item" :class="{'active' : isStep3}"><span
              class="progress__item-line"></span></div>
          <div v-if="isShowStep4" class="progress__item" :class="{'active' : isStep4}"><span
              class="progress__item-line"></span></div>
        </div>
      </div>
    </div>
    <div class="product-inner__cart">
      <div class="product-inner__quantity quantity quantity--bg">
        <button type="button" class="quantity__link quantity__link--minus" @click="quantityMinus()"></button>
        <input class="quantity__control" type="text" v-model="quantity" :min="minQuantity" :max="maxQuantity"
               :step="stepQuantity" @change="quantityChange" @input="quantityInput">
        <button type="button" class="quantity__link quantity__link--plus" @click="quantityPlus()"></button>
      </div>
      <span v-if="productInCart(productId)" class="detail-added-confirm">{{ cartAdded }}</span>
      <button v-else @click="addToCartAndPopupOpen({productId, quantity})"
              class="product-inner__btn default-btn default-btn--white">
        {{ cartAddToOrder }}
        <svg class="default-btn__icon" aria-hidden="true">
          <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-plus"></use>
        </svg>
      </button>
    </div>
  </div>


</template>
<script>
import {mapActions, mapGetters} from "vuex";
import InputRange from "@/components/utils/formElements/InputRange.vue";
import InputText from "@/components/utils/formElements/InputText.vue";
import InputFile from "@/components/utils/formElements/InputFile.vue";
import {IPFieldsView} from "@/mixins/IPFieldsView";
import {useIndividualPacking} from "@/hooks/useIndividualPacking";
import {IPFieldsRules} from "@/mixins/IPFieldsRules";

export default {
  name: "AddToCartDetail",
  mixins: [IPFieldsView, IPFieldsRules, useIndividualPacking],
  components: {
    InputRange, InputText, InputFile
  },
  props: {
    productId: Number,
    minQuantity: Number,
    maxQuantity: Number,
    stepQuantity: Number,
    productProperties: Object,
    countLayers: Array,
    profileCardboard: Array,
    colorFrontCardboard: Array,
    seal: Array,
    typePrint: Array,
    additionalParams: Array,
    accessories: Array,
    sizes: Array,
    sizesTitle: String,
    isStock: String,
    errorsForm: Array,
    cartBoardTitle: {
      type: [String],
      default: BX.message('CART_DETAIL_CARDBOARD_TITLE')
    },
    cartToggle: {
      type: [String],
      default: BX.message('CART_DETAIL_TOGGLE')
    },
    cartBoardText: {
      type: [String],
      default: BX.message('CART_DETAIL_CARDBOARD_TEXT')
    },
    cartProfileTitle: {
      type: [String],
      default: BX.message('CART_DETAIL_PROFILE_TITLE')
    },
    cartColorTitle: {
      type: [String],
      default: BX.message('CART_DETAIL_COLOR_TITLE')
    },
    cartApply: {
      type: [String],
      default: BX.message('CART_DETAIL_APPLY')
    },
    cartReset: {
      type: [String],
      default: BX.message('CART_DETAIL_RESET')
    },
    cartPrintingTitle: {
      type: [String],
      default: BX.message('CART_DETAIL_PRINTING_TITLE')
    },
    cartPrintingText: {
      type: [String],
      default: BX.message('CART_DETAIL_PRINTING_TEXT')
    },
    cartPrintingText2: {
      type: [String],
      default: BX.message('CART_DETAIL_PRINTING_TEXT_2')
    },
    cartPrintingText3: {
      type: [String],
      default: BX.message('CART_DETAIL_PRINTING_TEXT_3')
    },
    cartCommentText: {
      type: [String],
      default: BX.message('CART_DETAIL_PRINTING_COMMENT_TEXT')
    },
    cartAdditionally1: {
      type: [String],
      default: BX.message('CART_DETAIL_ADDITIONALLY_1')
    },
    cartAdditionally2: {
      type: [String],
      default: BX.message('CART_DETAIL_ADDITIONALLY_2')
    },
    cartAdditionally3: {
      type: [String],
      default: BX.message('CART_DETAIL_ADDITIONALLY_3')
    },
    cartCommentTitle: {
      type: [String],
      default: BX.message('CART_DETAIL_COMMENT_TITLE')
    },
    cartProgress: {
      type: [String],
      default: BX.message('CART_DETAIL_PROGRESS')
    },
    cartAdded: {
      type: [String],
      default: BX.message('CART_DETAIL_ADDED')
    },
    cartAddToOrder: {
      type: [String],
      default: BX.message('CART_DETAIL_ADD_TO_ORDER')
    },
    filePlaceHolder: {
      type: [String],
      default: BX.message('ADD_TO_CART_DETAIL_FILE')
    },
  },
  data() {
    return {
      selectedLength: this.productProperties.LENGTH.MIN,
      selectedWidth: this.productProperties.WIDTH.MIN,
      selectedHeight: this.productProperties.HEIGHT.MIN,
      selectedCountLayers: false,
      selectedProfileCardboard: false,
      selectedColorFrontCardboard: false,
      selectedSeal: false,
      selectedTypePrint: false,
      selectedTypePrintFile: false,
      selectedTypePrintFilePath: '',
      selectedTypePrintComment: '',
      selectedAdditionalParams: [],
      selectedAccessories: [],
      selectedComment: '',
      quantity: this.minQuantity,
      profileCardboardCustom: this.profileCardboard
    };
  },
  computed: {
    ...mapGetters('moduleCart', {
      productInCart: 'productInCart',
      cartItemByProductId: 'cartItemByProductId',
    }),
    isStep1: function () {
      return true;
    },
    isStep2: function () {
      if ((this.selectedCountLayers || this.countLayers.length <= 0) && (this.selectedProfileCardboard || this.profileCardboard.length <= 0)
          && (this.selectedColorFrontCardboard || this.colorFrontCardboard.length <= 0)) {
        return true;
      } else {
        return false;
      }
    },
    isShowStep2: function () {
      return this.countLayers.length > 0 || this.profileCardboard.length > 0 || this.colorFrontCardboard.length > 0;
    },
    isStep3: function () {
      if (this.selectedSeal == '2' || this.seal.length <= 0) {
        return true;
      } else return this.selectedSeal == '1' && (this.selectedTypePrint || this.typePrint.length <= 0) && this.selectedTypePrintFile &&
          this.selectedTypePrintFile[0] !== undefined && this.selectedTypePrintComment !== '';
    },
    isShowStep3: function () {
      return this.seal.length > 0;
    },
    isStep4: function () {
      if ((this.selectedAdditionalParams.length || this.additionalParams.length <= 0) && (this.selectedAccessories.length || this.accessories.length <= 0)) {
        return true;
      } else {
        return false;
      }
    },
    isShowStep4: function () {
      if (this.additionalParams.length > 0 || this.accessories.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    selectedCountLayers: function (val) {
      this.profileCardboardCustom.forEach(function (item, index) {
        this.profileCardboardCustom[index]['disabled'] = !item['count_layer_ids'].includes(val);
      }, this);
      this.selectedProfileCardboard = false;
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.productInCart(this.productId)) {
        let cartItem = this.cartItemByProductId(this.productId);
        this.quantity = cartItem.quantity;
      }
    }, 500);
  },
  methods: {
    ...mapActions('moduleCart', {
      addToCart: 'add',
      setQuantity: 'quantity',
    }),
    async addToCartAndPopupOpen({productId, quantity}) {
      if (quantity === 0) {
        window.toast.error('Ошибка добавления в корзину', 'Товара нет в наличии');
        return false;
      }

      let _tmr = window._tmr || (window._tmr = []);
      _tmr.push({type: 'reachGoal', id: 3352405, goal: 'add_to_order'});

      if (this.selectedSeal == '2') {
        this.selectedTypePrint = false;
        this.selectedTypePrintFile = false;
        this.selectedTypePrintComment = '';
      }

      let params = {
        'length': this.selectedLength,
        'width': this.selectedWidth,
        'height': this.selectedHeight,
        'countLayers': this.getRadioChekboxTextValue(this.selectedCountLayers, this.countLayers),
        'profileCardboard': this.getRadioChekboxTextValue(this.selectedProfileCardboard, this.profileCardboard),
        'colorFrontCardboard': this.getRadioChekboxTextValue(this.selectedColorFrontCardboard, this.colorFrontCardboard),
        'seal': this.getRadioChekboxTextValue(this.selectedSeal, this.seal),
        'typePrint': this.getRadioChekboxTextValue(this.selectedTypePrint, this.typePrint),
        'typePrintFile': this.selectedTypePrintFile,
        'typePrintComment': this.selectedTypePrintComment,
        'additionalParams': [],
        'accessories': [],
        'comment': this.selectedComment,
      };
      let arAdditionalParams = this.selectedAdditionalParams;
      arAdditionalParams.forEach(function (item) {
        let textValue = this.getRadioChekboxTextValue(item, this.additionalParams);
        params.additionalParams.push(textValue);
      }, this);
      let arAccessories = this.selectedAccessories;
      arAccessories.forEach(function (item) {
        let textValue = this.getRadioChekboxTextValue(item, this.accessories);
        params.accessories.push(textValue);
      }, this);

      this.addToCart({productId, quantity, params});

      window.FancyBox.show([{src: '#popup-confirm'}], {
        Toolbar: false,
        dragToClose: false,
        Thumbs: false,
        mainClass: 'fullscreen',
        autoFocus: true,
      });
    },
    getRadioChekboxTextValue(id, values) {
      let item = values.find((item) => item.id === id);
      if (item) {
        return item.name;
      } else {
        return '';
      }
    },
    quantityChange(event) {
      if (parseInt(event.target.value) > this.maxQuantity)
        this.quantity = this.maxQuantity;
      else if (event.target.value === '' || parseInt(event.target.value) < this.minQuantity)
        this.quantity = this.minQuantity;
      else if (event.target.value !== '')
        this.quantity = Number(event.target.value);

      this.quantityUpdate();
    },
    quantityInput(event) {
      if (event.target.value !== '' && !Number(event.target.value))
        this.quantity = this.minQuantity;

      this.quantityUpdate();
    },
    quantityPlus() {
      let tempQuantity;

      if (this.maxQuantity < this.stepQuantity) {
        tempQuantity = this.quantity + 1;
      } else if (this.quantity % this.stepQuantity === 0) {
        tempQuantity = this.stepQuantity * (this.quantity / this.stepQuantity + 1);
      } else {
        tempQuantity = this.stepQuantity * Math.ceil(this.quantity / this.stepQuantity);
      }

      if (tempQuantity < this.maxQuantity) {
        this.quantity = tempQuantity;
        this.quantityUpdate();
      } else {
        this.quantity = this.maxQuantity;
        this.quantityUpdate();
      }
    },
    quantityMinus() {
      let tempQuantity;

      if (this.maxQuantity < this.stepQuantity) {
        tempQuantity = this.quantity - 1;
      } else if (this.quantity % this.stepQuantity === 0) {
        tempQuantity = this.stepQuantity * (this.quantity / this.stepQuantity - 1);
      } else {
        tempQuantity = this.stepQuantity * Math.floor(this.quantity / this.stepQuantity);
      }

      if (tempQuantity > this.minQuantity) {
        this.quantity = tempQuantity;
        this.quantityUpdate();
      } else {
        this.quantity = this.minQuantity;
        this.quantityUpdate();
      }
    },
    quantityUpdate() {
      if (this.productInCart(this.productId)) {
        let cartItem = this.cartItemByProductId(this.productId);
        let cartId = cartItem.id;
        let quantity = this.quantity;
        this.setQuantity({cartId, quantity});
      }
    },
    handleFileUpload() {
      if (this.$refs.selectedTypePrintFile) {
        this.selectedTypePrintFile = this.$refs.selectedTypePrintFile.files[0];
      } else {
        this.selectedTypePrintFile = false;
      }
    },
    setValue(fieldCode, fieldType, eventVal) {
      if (fieldCode === 'LENGTH')
        this.selectedLength = eventVal;
      else if (fieldCode === 'WIDTH')
        this.selectedWidth = eventVal;
      else if (fieldCode === 'HEIGHT')
        this.selectedHeight = eventVal;
    },
    getSizeValue(type, fieldCode) {
      if (fieldCode === 'LENGTH' && type === 'min')
        return this.productProperties.LENGTH.MIN;
      else if (fieldCode === 'LENGTH' && type === 'max')
        return this.productProperties.LENGTH.MAX;
      else if (fieldCode === 'WIDTH' && type === 'min')
        return this.productProperties.WIDTH.MIN
      else if (fieldCode === 'WIDTH' && type === 'max')
        return this.productProperties.WIDTH.MAX
      else if (fieldCode === 'HEIGHT' && type === 'min')
        return this.productProperties.HEIGHT.MIN
      else if (fieldCode === 'HEIGHT' && type === 'max')
        return this.productProperties.HEIGHT.MAX
    },
    getCurSizeValue(fieldCode) {
      if (fieldCode === 'LENGTH')
        return this.selectedLength
      else if (fieldCode === 'WIDTH')
        return this.selectedWidth
      else if (fieldCode === 'HEIGHT')
        return this.selectedHeight
    },
    setFileValue(eventVal) {
      this.selectedTypePrintFile = eventVal;
    },
    ApplyClick() {
      window.FancyBox.close();
    },
    ResetParametersClick() {
      this.selectedCountLayers = false;
      this.selectedProfileCardboard = false;
      this.selectedColorFrontCardboard = false;
      window.FancyBox.close();
    },
    ResetSealClick() {
      this.selectedSeal = false;
      this.selectedTypePrint = false;
      this.selectedTypePrintFile = false;
      this.selectedTypePrintComment = '';
      window.FancyBox.close();
    },
    ResetAdditionalClick() {
      this.selectedAdditionalParams = [];
      this.selectedAccessories = [];
      window.FancyBox.close();
    },
    getTypePrintFileName() {
      if (this.selectedTypePrintFile && this.selectedTypePrintFile[0] !== undefined)
        return this.selectedTypePrintFile[0]['name']
    }
  }
}
</script>